import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO:
 */
export const discardEdits = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.discardEdits.relay((forwardTo, { target }) =>
      rxjs.of(
        forwardTo(plugin.edited.actions.putInSelectionLookup, {
          input: { key: target, value: { release: true } },
        }),
      ),
    ).asObservable,
)
